import { EXTERNAL_LINK } from '@/constants/externalLink'
import { ROUTE_PATH } from '@/constants/routePath'
import classnames from 'classnames/bind'
import Link from 'next/link'
import { ReactNode } from 'react'
import AboutPageLayout from '../utils/AboutPageLayout'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type PolicyItemType = {
  title: string
  description: ReactNode
}

const policies: PolicyItemType[] = [
  {
    title: '第 1 条（総則）',
    description:
      '本プライバシーポリシーは、ライブモールクラブ株式会社（以下「当社」という）が運営 する Live Mall Club（以下「本プラットフォーム」という）において、利用者の個人情報を どのように取り扱うかを定めたものです。',
  },
  {
    title: '第 2 条（収集する情報）',
    description: (
      <>
        当社は、本プラットフォームの運営に際し、以下の個人情報を収集することがありま す。
        <ol>
          <li>会員情報（氏名、住所、電話番号、メールアドレス、生年月日）</li>
          <li>決済情報（クレジットカード情報、銀行口座情報など）</li>
          <li>取引履歴（購入・販売履歴、決済状況）</li>
          <li>デバイス情報（IP アドレス、ブラウザ種類、アクセス履歴、クッキー情報）</li>
          <li>お問い合わせ情報（サポート対応履歴）</li>
        </ol>
      </>
    ),
  },
  {
    title: '第 3 条（個人情報の利用目的）',
    description: (
      <>
        当社は、収集した個人情報を以下の目的で利用します。
        <ol>
          <li>本プラットフォームの運営、会員管理</li>
          <li>商品の売買、配送、決済手続きの管理</li>
          <li>ユーザーサポート、問い合わせ対応</li>
          <li>本プラットフォームの改善、マーケティング活動</li>
          <li>サービスの保守、管理のため</li>
          <li>本プラットフォーム及びサービスの改善のため</li>
          <li>法令遵守および不正行</li>
          <li>上記に付帯・関連する目的のため</li>
        </ol>
      </>
    ),
  },
  {
    title: '第 4 条（個人情報の第三者提供）',
    description: (
      <>
        当社は、以下の場合を除き、利用者の個人情報を第三者に提供しません。
        <ol>
          <li>ユーザーの同意がある場合</li>
          <li>法令に基づく場合</li>
          <li>人の生命，身体又は財産の保護のために必要がある場合であって，お客様の同意を得ることが困難であるとき。</li>
          <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって，お客様の同意を得ることが困難であるとき。</li>
        </ol>
        国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂
        行することに対して協力する必要がある場合であって，お客様の同意を得ることによ り当該事務の遂行に支障を及ぼすおそれがあるとき。
      </>
    ),
  },
  {
    title: '第 5 条（個人情報の管理）',
    description: (
      <ol>
        <li>当社は、個人情報の漏洩、滅失、毀損を防ぐために適切な管理措置を講じます。</li>
        <li>個人情報の保存期間は、法令に基づく必要な期間とし、不要となった情報は適切に削除・廃棄します。</li>
      </ol>
    ),
  },
  {
    title: '第 6 条（クッキー（Cookie）について） ',
    description: (
      <ol>
        <li>
          本プラットフォームでは、ユーザーの利便性向上およびアクセス解析のためにクッキーを使用することがあります。
          <br />
          Cookie とは，任意の文字が書かれた小さなファイルのことで，ユーザーがウェブサイ
          トを閲覧した際に，ウェブサーバとユーザーのインターネット閲覧ソフト（ブラウザ）との
          間でやりとりされ，ユーザーの端末に保存されるものです。これを利用することにより，
          お客様の閲覧履歴，サービス利用履歴，位置情報等，個人が特定できない属性情報
          を取得することがあります。ユーザーは，ブラウザの設定により，事前に，Cookie を 使用しているサイトであることを表示したり，Cookie
          の無効化及び保存済みの Cookie の削除をしたりすることができます。Cookie の利用を拒否し又は Cookie を
          削除した場合，ウェブサイトでご利用いただくことができる機能が制限される可能性が ありますのでご了承ください。
        </li>
      </ol>
    ),
  },
  {
    title: '第 7 条（個人情報の開示、訂正、削除）',
    description: (
      <ol>
        <li>ユーザーは、自己の個人情報について、開示、訂正、削除を求めることができます。</li>
        <li>その際、当社所定の手続きに従い、本人確認を行うものとします。</li>
      </ol>
    ),
  },
  {
    title: '第 8 条（プライバシーポリシーの変更）',
    description: (
      <ol>
        <li>当社は、必要に応じて本プライバシーポリシーを変更することができます。</li>
        <li>変更後のプライバシーポリシーは、本プラットフォーム上で告知した時点で効力を生じるものとします。</li>
      </ol>
    ),
  },
  {
    title: '第 9 条（お問い合わせ）',
    description: (
      <>
        本プライバシーポリシーに関するお問い合わせは、以下の窓口までご連絡ください。
        <br />
        ライブモールクラブ株式会社
        <br />
        所在地：〒141-0021 東京都品川区上大崎 2-2-6
        <br />
        電話番号：03-5422-8087
        <br />
        メールアドレス：
        <a href={`mailto:${EXTERNAL_LINK.LIVE_MALL_CLUB_SERVICE_EMAIL}`} className={cx('email-link')}>
          {EXTERNAL_LINK.LIVE_MALL_CLUB_SERVICE_EMAIL}
        </a>
        <br />
        （受付時間：平日 10:00～16:00）
      </>
    ),
  },
  {
    title: '附則',
    description: '本プライバシーポリシーは、2025 年〇月〇日より施行します。',
  },
]

const PrivacyPolicy = () => {
  return (
    <AboutPageLayout>
      <AboutPageLayout.SectionTitle>Live Mall Club プライバシーポリシー</AboutPageLayout.SectionTitle>
      <div className={cx('privacy-policy')}>
        {policies.map((policy, index) => (
          <div key={index}>
            <AboutPageLayout.SectionTitle>{policy.title}</AboutPageLayout.SectionTitle>
            <div>{policy.description}</div>
          </div>
        ))}
      </div>
      <Link href={ROUTE_PATH.ABOUT_TERMS} className={cx('link')}>
        Live Mall Club Terms of Use
      </Link>
    </AboutPageLayout>
  )
}

export default PrivacyPolicy
